import { $, $$ } from './../helpers/qsa'
import Siema from 'siema'

// Carousel setup
Siema.prototype.addControls = function() {
    // Create controls
    this.prevControl = createControl('prev')
    this.nextControl = createControl('next')

    // Append
    this.selector.parentNode.appendChild(this.prevControl)
    this.selector.parentNode.appendChild(this.nextControl)

    // Bind events
    this.prevControl.addEventListener('click', () => this.prev(), false)
    this.nextControl.addEventListener('click', () => this.next(), false)
}

const createControl = type => {
    let el = document.createElement('button')
    el.className = `carousel__control  carousel__control--${type}`

    return el
}

// Init
$$('.carousel').forEach(el => {

    // Get items
    const items = $('.carousel__items', el)

    if ( items.children.length > 1 ) {
        const siema = new Siema({
            selector: items
        })

        // Add controls
        siema.addControls()
    }
})
